import { WarningFilled } from '@ant-design/icons';
import { useQuery } from 'urql';
import { dirhams, membersCount } from '../format';
import { graphql } from '../gql';
import { latePayersSummary } from './summary';
import './late-payers.css';

const LatePayersDocument = graphql(`
  query LatePayersAlert {
    arrearsList {
      nodes {
        memberId
        amountDue
        daysOverdue
        publiclyListed
      }
    }
    currentSettings {
      publicArrearsAfterDays
    }
  }
`);

/**
 * «14 عضواً متأخرون عن الأداء: 3.450,00 درهم — منهم 5 منذ أكثر من 60 يوماً».
 * From arqam's arrears list (current data: who owes now, how late); hidden
 * when nobody is late. The whole alert is one big button to the list.
 */
export function LatePayersAlert({
  onOpen,
  actionLabel = 'اللائحة',
}: {
  onOpen: () => void;
  actionLabel?: string;
}) {
  const [{ data }] = useQuery({
    query: LatePayersDocument,
    requestPolicy: 'cache-and-network',
  });
  if (!data) return null;
  const summary = latePayersSummary(
    (data.arrearsList?.nodes ?? []).flatMap((n) => (n ? [n] : [])),
  );
  if (summary.lateCount === 0) return null;
  const after = data.currentSettings?.publicArrearsAfterDays ?? 60;

  return (
    <button type="button" className="late-alert" onClick={onOpen}>
      <WarningFilled className="late-alert-icon" />
      <span className="late-alert-text">
        <strong>
          {membersCount(summary.lateCount)} متأخرون عن الأداء:{' '}
          {dirhams(summary.lateAmount)}
        </strong>
        {summary.publicCount > 0 && (
          <span>
            منهم {summary.publicCount} منذ أكثر من {after} يوماً (في اللائحة
            العامة)
          </span>
        )}
      </span>
      <span className="late-alert-action">{actionLabel} ‹</span>
    </button>
  );
}
